import React from 'react';

const FrequentlyAskedQuestion = () => {
  return (
    <div className="md:px-24 mx-auto px-4 text-black font-sans md:mb-20 mb-10">
      <h2 className="md:text-[36px] text-[14px] font-bold text-[#03897B] mb-4">FREQUENTLY ASKED QUESTIONS</h2>
      <p className="md:text-[24px] text-[10px] font-light mb-6">Website frequently asked questions</p>
      <p className="md:text-[24px] text-[10px] font-light text-black mb-8">Updated: 30th April 2025</p>

      <div className="md:space-y-7 space-y-5 font-light text-[10px] leading-relaxed md:text-[24px]">
        <section>
          <h3 className="mb-1 md:-mb-2">What types of training or consultancy services do you offer?</h3>
          <p>We offer a wide range of services including:</p>
          <ul className="md:-mt-2 md:leading-[1.40]">
            <li>Corporate training (e.g. leadership, project management, sales)</li>
            <li>Skills development programmes</li>
            <li>SETA-accredited learnerships</li>
            <li>Organisational development consulting</li>
            <li>B-BBEE strategy & compliance support</li>
            <li>HR, talent management, and workforce planning</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">2. Are your training programmes accredited?</h3>
          <p className='md:leading-[1.25]'>Yes, many of our programmes are accredited with relevant SETA bodies (e.g. Services SETA, MICT SETA). Non-accredited short courses and customised training are also available based on client needs.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">3. Can you customise training to suit our company’s needs?</h3>
          <p  className='md:leading-[1.25]'>Absolutely! We work closely with your team to develop bespoke training programmes aligned with your industry, workforce needs, and company goals.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">4. Do you offer virtual or online training options?</h3>
          <p>Yes. We provide:</p>
          <ul className="md:-mt-2 md:leading-[1.40]">
            <li>Instructor-led virtual classrooms</li>
            <li>Self-paced eLearning modules</li>
            <li>Hybrid training solutions (blended learning)</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">5. What are your consultancy fees and how are they structured?</h3>
          <p>Fees vary based on the scope and complexity of the engagement. We offer:</p>
          <ul className="md:-mt-2 md:leading-[1.40]" >
            <li>Hourly or daily consultant rates</li>
            <li>Fixed-fee project pricing</li>
            <li>Retainer-based models for long-term partnerships</li>
          </ul>
          <p>Custom quotes are provided after a needs analysis.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">6. Do you assist with Skills Development and B-BBEE compliance?</h3>
          <p>Yes, we provide full support with:</p>
          <ul className="md:-mt-2 md:leading-[1.40]">
            <li>Workplace Skills Plans (WSP) & Annual Training Reports (ATR)</li>
            <li>Learnerships, internships, and bursary implementation</li>
            <li>SETA funding and grant applications</li>
            <li>B-BBEE scorecard optimisation through training initiatives</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">7. Where are you based, and do you serve clients nationally?</h3>
          <p  className='md:leading-[1.25]'>We are based in [City, South Africa], but we serve clients across South Africa, both onsite and remotely.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">8. Can we claim from our Skills Development Levy (SDL) for your training?</h3>
          <p  className='md:leading-[1.25]'>Yes. If you are a levy-paying company, our accredited programmes qualify you to claim back from your SETA. We also assist with documentation and submission.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">9. How do we get started with a consultation or training project?</h3>
          <p  className='md:leading-[1.25]'>Simply contact us via the website’s Contact Form, email, or call. We will schedule an initial consultation to understand your needs and tailor a proposal accordingly.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">10. Do you work with government or non-profit organisations?</h3>
          <p  className='md:leading-[1.25]'>Yes, we regularly work with public sector departments, municipalities, and NGOs for training and organisational development projects.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">11. Can you help us identify skills gaps in our organisation?</h3>
          <p  className='md:leading-[1.25]'>Definitely. We offer skills audits, training needs analyses, and competency assessments to identify areas for growth and development.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">12. How do we know the training was effective?</h3>
          <p  className='md:leading-[1.25]'>We offer post-training evaluations, participant feedback, and impact assessments to measure effectiveness and ROI. Certificates of completion or competence are also issued.</p>
        </section>

        <section>
          <h3 className="mb-1 md:-mb-2">13. Contact Information</h3>
          <p className='md:leading-[1.40]'>
            If you have any questions regarding these Terms, please contact us at:<br />
            📧 Email: Info@adluck.co.za<br />
            📍 Address: Midstream, Centurion, Gauteng, South Africa
          </p>
        </section>
      </div>
    </div>
  );
};

export default FrequentlyAskedQuestion;
